import { Component } from '@angular/core';

@Component({
  selector: 'app-service-sidebar',
  templateUrl: './service-sidebar.component.html',
  styleUrl: './service-sidebar.component.scss'
})
export class ServiceSidebarComponent {

}
